import React from "react";
import { ArrowLeft } from "lucide-react";

interface AppNavbarProps {
  onBack?: () => void;
  selectedTab: "variants" | "loggers";
  onTabChange: (tab: "variants" | "loggers") => void;
  title: string;
}

const AppNavbar: React.FC<AppNavbarProps> = ({
  onBack,
  selectedTab,
  onTabChange,
  title,
}) => {
  return (
    <nav className="navbar bg-white shadow-sm border-bottom sticky-top">
      <div className="container-fluid">
        <div className="d-flex align-items-center gap-3 py-2 w-100">
          {onBack && (
            <button
              onClick={onBack}
              className="btn btn-outline-secondary d-flex align-items-center justify-content-center p-2 rounded-circle border-0 hover-bg-light"
              style={{ width: "40px", height: "40px" }}
            >
              <ArrowLeft size={18} className="text-secondary" />
            </button>
          )}

          {/* Chrome-style Tabs */}
          <div className="d-flex align-items-center ms-2 flex-grow-1">
            <div className="tabs-container d-flex border-bottom w-100">
              {/* Variants Tab */}
              <button
                className={`tab-btn px-4 py-2 border-0 bg-transparent fw-medium ${
                  selectedTab === "variants" ? "active-tab" : "inactive-tab"
                }`}
                onClick={() => onTabChange("variants")}
              >
                {title}
              </button>

              {/* Loggers Tab */}
              <button
                className={`tab-btn px-4 py-2 border-0 bg-transparent fw-medium ${
                  selectedTab === "loggers" ? "active-tab" : "inactive-tab"
                }`}
                onClick={() => onTabChange("loggers")}
              >
                Loggers
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* CSS styles inside component */}
      <style>{`
        .tabs-container {
          position: relative;
        }

        .tab-btn {
          min-width: 120px;
          font-size: 14px;
          position: relative;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          margin-right: 4px;
          transition: all 0.2s ease;
        }

        .tab-btn.active-tab {
          background: #fff;       
          color: #4fd1c5;               
          border: 1px solid #38b2ac; 
          border-bottom: none;
          z-index: 2;
          box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
          font-weight: 600;
        }

        .tab-btn.active-tab:hover {
          background: #fff;        
          color: #38b2ac;
        }

        .tab-btn.inactive-tab {
          background: #f8f9fa;
          color: #6c757d;
          border: 1px solid transparent;
        }

        .tab-btn.inactive-tab:hover {
          background: #e9ecef;
          color: #495057;
        }
      `}</style>
    </nav>
  );
};

export default AppNavbar;
